import { Link } from "react-router-dom";
import Logo from "@/components/Logo";

// Small, presentational shell used by both Privacy and Terms pages so the
// two legal surfaces share the same header/footer chrome without pulling
// in a bigger layout dependency. Kept intentionally minimal.
export default function LegalPage({ title, lastUpdated, children, testId }) {
  return (
    <div
      className="min-h-screen"
      style={{ background: "var(--ta-bg)" }}
      data-testid={testId}
    >
      <header
        className="sticky top-0 z-30 backdrop-blur-md"
        style={{ background: "rgba(249,248,246,0.85)" }}
      >
        <div className="w-full max-w-screen-lg mx-auto px-5 sm:px-8 h-16 flex items-center justify-between">
          <Link to="/" data-testid="legal-home-link"><Logo /></Link>
          <Link
            to="/"
            className="text-sm font-medium hover:underline"
            style={{ color: "var(--ta-brand)" }}
            data-testid="legal-back-home"
          >
            Back to home
          </Link>
        </div>
      </header>

      <main className="w-full max-w-screen-md mx-auto px-5 sm:px-8 py-16">
        <h1
          className="text-4xl sm:text-5xl font-bold tracking-tight mb-3"
          style={{ color: "var(--ta-text)" }}
          data-testid="legal-heading"
        >
          {title}
        </h1>
        <p
          className="text-sm mb-10"
          style={{ color: "var(--ta-text-secondary)" }}
          data-testid="legal-last-updated"
        >
          Last updated: {lastUpdated}
        </p>

        <div
          className="prose prose-lg max-w-none"
          style={{ color: "var(--ta-text)" }}
        >
          {children}
        </div>
      </main>

      <footer className="w-full max-w-screen-lg mx-auto px-5 sm:px-8 pb-16">
        <div
          className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 pt-8 border-t text-sm"
          style={{ borderColor: "var(--ta-border)", color: "var(--ta-text-secondary)" }}
        >
          <p>&copy; 2026 Your Monday Brief. Help first. The money follows.</p>
          <div className="flex gap-5">
            <Link to="/privacy" className="hover:underline">Privacy Policy</Link>
            <Link to="/terms" className="hover:underline">Terms of Service</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
